function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { InfoPopover, HoursOfOperationV2, addresses, phones as phonesUtils } from '@unite-us/client-utils';
import { Icon } from '@unite-us/ui';
import ClientItem from './components/ClientItem';
import InsuranceInfo from './components/InsuranceInfo';
import { useAppContext } from '../../app/AppContext';
import { formatDemographicInfo } from './utils';
import { COMPONENTS, UTILS } from '../../api/config';
function ClientSummary(_ref) {
  var contact = _ref.contact;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    clientData = _useState2[0],
    setClientData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    militaryInfo = _useState4[0],
    setMilitaryInfo = _useState4[1];
  var _useAppContext = useAppContext(),
    enums = _useAppContext.enums;
  var MethodsOfContact = COMPONENTS.MethodsOfContact,
    VoiceMailOk = COMPONENTS.VoiceMailOk,
    StatusSelect = COMPONENTS.StatusSelect;
  var generateClientData = UTILS.generateClientData,
    getDobData = UTILS.getDobData,
    formatAddress = UTILS.formatAddress,
    formatHouseholdCount = UTILS.formatHouseholdCount,
    filterMilitaryInfo = UTILS.filterMilitaryInfo,
    findPrimaryOrFirst = UTILS.findPrimaryOrFirst,
    dollarAmount = UTILS.dollarAmount;
  var militaryData = useCallback(function () {
    return _.filter(filterMilitaryInfo(contact, enums, true), function (data) {
      return !_.isEmpty(data.value);
    });
  }, [contact, enums, filterMilitaryInfo]);
  var formatClientData = useCallback(function () {
    var phoneNumber = findPrimaryOrFirst(contact.phone_numbers).phone_number;
    var emailAddress = findPrimaryOrFirst(contact.email_addresses).email_address;
    var address = addresses.findMainAddress(contact.addresses);
    var clientData = [generateClientData('dob', getDobData(contact === null || contact === void 0 ? void 0 : contact.date_of_birth)), generateClientData('race', formatDemographicInfo(contact === null || contact === void 0 ? void 0 : contact.race)), generateClientData('ethnicity', formatDemographicInfo(contact === null || contact === void 0 ? void 0 : contact.ethnicity)), generateClientData('gender', formatDemographicInfo(contact === null || contact === void 0 ? void 0 : contact.gender)), generateClientData('tel', phonesUtils.formatPhoneNumber(phoneNumber)), generateClientData('email', emailAddress), generateClientData('address', formatAddress(address)), generateClientData('household', formatHouseholdCount(_.get(contact, 'household.total'))), generateClientData('household monthly income', dollarAmount(contact.gross_monthly_income))];
    return _.filter(clientData, function (data) {
      return !_.isEmpty(data.value);
    });
  }, [contact, dollarAmount, findPrimaryOrFirst, formatAddress, formatHouseholdCount, generateClientData, getDobData]);
  var timeslots = _.get(contact, 'contact_preference.timeslots');
  var contactMethods = _.get(contact, 'contact_preference.preferred_contact_methods', []);
  var isVoicemailOK = _.get(contact, 'contact_preference.voice_mail_ok', null);
  var contactNotes = _.get(contact, 'contact_preference.contact_notes');
  var showVoiceMailOk = _.includes(contactMethods, 'phone') && isVoicemailOK != null;
  var warnContactNotes = !!contactNotes;
  var warnVoicemail = _.includes(contactMethods, 'phone') && isVoicemailOK === false;
  var warnTimeslots = !_.isEmpty(timeslots);
  var showContactRequirementsBanner = warnContactNotes || warnVoicemail || warnTimeslots;
  var renderClientItems = function renderClientItems(items) {
    return !_.isEmpty(items) ? /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, _.map(items, function (_ref2) {
      var label = _ref2.label,
        value = _ref2.value;
      return /*#__PURE__*/React.createElement(ClientItem, {
        label: label,
        value: value,
        key: label
      });
    })) : null;
  };
  useEffect(function () {
    setClientData(formatClientData());
    setMilitaryInfo(militaryData());
  }, [contact, enums, formatClientData, militaryData]);
  return /*#__PURE__*/React.createElement("div", {
    className: "client-summary"
  }, contact && /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(StatusSelect, {
    contact: contact
  })), showContactRequirementsBanner ? /*#__PURE__*/React.createElement("div", {
    className: "contact-requirements mt-4 ml-1 text-red flex"
  }, /*#__PURE__*/React.createElement("div", null, "This client has specific contact requirements. Check these requirements before contacting the client."), /*#__PURE__*/React.createElement(Icon, {
    icon: "IconInfoCircle",
    className: "ml-1 mb-0.5",
    color: "#CF2A2A",
    id: "anchor-id-info-popover-contact-methods"
  }), /*#__PURE__*/React.createElement(InfoPopover, {
    id: "info-popover-contact-methods",
    placement: "bottom-start",
    hiddenTooltip: false,
    tooltipText: /*#__PURE__*/React.createElement("div", {
      className: "p-4 text-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-3"
    }, "Methods of Contact:"), /*#__PURE__*/React.createElement(MethodsOfContact, {
      contactMethods: contactMethods,
      enums: enums
    })), showVoiceMailOk && /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(VoiceMailOk, {
      contactMethods: contactMethods,
      isVoicemailOK: isVoicemailOK
    })), !_.isEmpty(timeslots) && /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(HoursOfOperationV2, {
      closedText: "Do not contact",
      endTimeKey: "end_time",
      hours: timeslots,
      hoursLabel: "Contact Times:",
      showAll: true,
      startTimeKey: "start_time"
    })), contactNotes && /*#__PURE__*/React.createElement("div", {
      className: "flex mt-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "whitespace-pre mr-3"
    }, "Contact Notes:"), /*#__PURE__*/React.createElement("div", null, contactNotes)))
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "client-summary__data-display"
  }, renderClientItems(clientData), /*#__PURE__*/React.createElement(InsuranceInfo, {
    contact: contact
  }), renderClientItems(militaryInfo)));
}
ClientSummary.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired,
    military: PropTypes.shape({
      affiliation: PropTypes.string,
      current_status: PropTypes.string
    }),
    contact_preference: PropTypes.shape({
      preferred_contact_methods: PropTypes.array,
      timeslots: PropTypes.object
    }),
    contactInsurances: PropTypes.array,
    phone_numbers: PropTypes.array,
    email_addresses: PropTypes.string,
    addresses: PropTypes.string,
    date_of_birth: PropTypes.string,
    race: PropTypes.string,
    ethnicity: PropTypes.string,
    gender: PropTypes.string,
    gross_monthly_income: PropTypes.string
  }).isRequired,
  enums: PropTypes.object.isRequired,
  contactInsurances: PropTypes.arrayOf(PropTypes.shape({
    planId: PropTypes.string,
    memberId: PropTypes.string,
    endDate: PropTypes.string
  })),
  militaryInfo: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  isFetching: PropTypes.bool
};
ClientSummary.defaultProps = {
  showConsent: true,
  militaryInfo: []
};
export default ClientSummary;
//# sourceMappingURL=index.js.map